import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import { func } from "prop-types";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import XLSX from "xlsx-js-style";
import moment from "moment";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";

function ListadoInventarios() {
  const { user } = useContext(AuthContext);
  const URL_INVENTARIOS = `${process.env.REACT_APP_URL_INVENTARIOS}`;
  const URL_LINEAS = process.env.REACT_APP_URL_LINEAS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_FAMILIAS = process.env.REACT_APP_URL_FAMILIAS;
  const URL_COLECCIONES = process.env.REACT_APP_URL_COLECCIONES;
  const URL_ARTICULOS = process.env.REACT_APP_URL_ARTICULOS;
  const URL_ARTICULOS_PROPORCION = process.env.REACT_APP_URL_ARTICULOS_PROPORCION;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_AJUSTES_INVENTARIO = process.env.REACT_APP_URL_AJUSTES_INVENTARIO;
  const URL_ARTICULOS_AJUSTES_INV = process.env.REACT_APP_URL_ARTICULOS_AJUSTES_INV;
  const URL_TRASPASOS_SALIDA = process.env.REACT_APP_URL_TRASPASOS_SALIDA;
  const URL_ARTICULOS_TS = process.env.REACT_APP_URL_ARTICULOS_TS;
  const URL_TRASPASOS_ENTRADA = process.env.REACT_APP_URL_TRASPASOS_ENTRADA;
  const URL_ARTICULOS_TE = process.env.REACT_APP_URL_ARTICULOS_TE;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const AREAS_GENERAL = process.env.REACT_APP_AREAS_GENERAL;
  const AREAS_CEDIS = process.env.REACT_APP_AREAS_CEDIS;

  const [lineas, setLineas] = useState([]);
  const [selectedLineaFiltro, setSelectedLineaFiltro] = useState("");
  const [selectedTipoFiltro, setSelectedTipoFiltro] = useState("");
  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");
  const [familias, setFamilias] = useState([]);
  const [selectedFamiliaFiltro, setSelectedFamiliaFiltro] = useState("");
  const [colecciones, setColecciones] = useState([]);
  const [selectedColeccion, setSelectedColeccion] = useState("");
  const [selectedAno, setSelectedAno] = useState("");
  const [areas, setAreas] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  
  const [articulos, setArticulos] = useState([]);
  const [selectedArticulo, setSelectedArticulo] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [activo, setActivo] = useState("");

  const [file, setFile] = useState();
  const [photo, setPhoto] = useState();
  const [idEditArticulo, setIdEditArticulo] = useState("");
  const URL_FILEPOST = process.env.REACT_APP_URL_UPPROFILE;
  const [modalFoto, setModalFoto] = useState(false);
  const toggleFoto = () => setModalFoto(!modalFoto);

  const [modalTablaColores, setModalTablaColores] = useState(false);
  const toggleTablaColores = () => setModalTablaColores(!modalTablaColores);
  const [arrayColores, setArrayColores] = useState([]);

  // Modal Ajuste de Cantidad
  const [modalAjuste, setModalAjuste] = useState(false);
  const toggleAjuste = () => setModalAjuste(!modalAjuste);
  const [ajusteIdInv, setAjusteIdInv] = useState("");
  const [ajusteIdArt, setAjusteIdArt] = useState("");
  const [ajusteIdArea, setAjusteIdArea] = useState("");
  const [ajusteCodigo, setAjusteCodigo] = useState("");
  const [ajusteNombre, setAjusteNombre] = useState("");
  const [ajusteArea, setAjusteArea] = useState("");
  const [ajusteCantInv, setAjusteCantInv] = useState(0);
  const [ajusteCantidadReal, setAjusteCantidadReal] = useState(0);
  const [ajusteValidando, setAjusteValidando] = useState(false);

  // Modal Editar Precio Venta
  const [modalPrecio, setModalPrecio] = useState(false);
  const togglePrecio = () => setModalPrecio(!modalPrecio);
  const [precioIdArt, setPrecioIdArt] = useState("");
  const [precioCodigo, setPrecioCodigo] = useState("");
  const [precioNombre, setPrecioNombre] = useState("");
  const [precioVentaActual, setPrecioVentaActual] = useState(0);
  const [precioVentaNueva, setPrecioVentaNueva] = useState(0);
  const [precioVenta2Actual, setPrecioVenta2Actual] = useState(0);
  const [precioVenta2Nueva, setPrecioVenta2Nueva] = useState(0);
  const [precioVenta3Actual, setPrecioVenta3Actual] = useState(0);
  const [precioVenta3Nueva, setPrecioVenta3Nueva] = useState(0);
  const [precioVenta4Actual, setPrecioVenta4Actual] = useState(0);
  const [precioVenta4Nueva, setPrecioVenta4Nueva] = useState(0);
  const [precioValidando, setPrecioValidando] = useState(false);

  // Modal Unificar Modelos (mismo almacen)
  const [modalUnificar, setModalUnificar] = useState(false);
  const toggleUnificar = () => setModalUnificar(!modalUnificar);
  const [uniSourceIdInv, setUniSourceIdInv] = useState("");
  const [uniSourceIdArt, setUniSourceIdArt] = useState("");
  const [uniSourceCodigo, setUniSourceCodigo] = useState("");
  const [uniSourceNombre, setUniSourceNombre] = useState("");
  const [uniSourceCantidad, setUniSourceCantidad] = useState(0);
  const [uniSourceIdArea, setUniSourceIdArea] = useState("");
  const [uniSourceArea, setUniSourceArea] = useState("");
  const [uniTargetIdInv, setUniTargetIdInv] = useState("");
  const [uniTargetIdArt, setUniTargetIdArt] = useState("");
  const [uniOpciones, setUniOpciones] = useState([]);
  const [uniValidando, setUniValidando] = useState(false);

  const [totalTotal, setTotalTotal] = useState(0);
  const [totalTotalCajas, setTotalTotalCajas] = useState(0);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  // "" = Todos, "ConCantidad" = solo cantidad > 0, "En0" = solo cantidad <= 0
  const [filtroCantidad, setFiltroCantidad] = useState("");
  // Rango de cantidad. Las filas en 0 quedan fuera de estos filtros.
  const [cantidadMayorQue, setCantidadMayorQue] = useState("");
  const [cantidadMenorQue, setCantidadMenorQue] = useState("");
  // Que lista de precios se muestra en la unica columna de precio (1..4)
  const [listaPrecio, setListaPrecio] = useState("1");

  // Mapa idArticulo -> piezas pendientes de surtir (pedidos abiertos y activos)
  const [pendientePorArticulo, setPendientePorArticulo] = useState({});

  // Helper compartido por la tabla, el PDF y el Excel: aplica el rango
  // mayor/menor que. Las filas en 0 no juegan (quedan fuera si hay rango).
  const pasaRangoCantidad = (cantidad) => {
    const min = cantidadMayorQue === "" ? null : parseFloat(cantidadMayorQue);
    const max = cantidadMenorQue === "" ? null : parseFloat(cantidadMenorQue);
    if (min === null && max === null) return true;
    const c = parseFloat(cantidad) || 0;
    if (c === 0) return false;
    if (min !== null && !(c > min)) return false;
    if (max !== null && !(c < max)) return false;
    return true;
  };

  // Key del campo de precio segun la lista elegida.
  const ventaKeySel = listaPrecio === "1" ? "venta" : `venta${listaPrecio}`;

  // Disponible = cantidad - pendiente de surtir (pedidos abiertos y activos).
  // El pendiente se descuenta solo en CEDIS, que es el almacen desde donde se
  // surte; en los demas almacenes el disponible es la cantidad tal cual (si se
  // descontara en cada fila, un articulo presente en N almacenes restaria N veces).
  const calculaDisponible = (row) => {
    const cant = parseFloat(row.cantidad) || 0;
    if (String(row.idArea) !== String(AREAS_CEDIS)) return cant;
    const pend = pendientePorArticulo[String(row.idArticulo)] || 0;
    return cant - pend;
  };

  // Opciones del autocomplete de Codigo, ordenadas alfabeticamente por codigo
  // y agrupadas por su primera letra (los numericos caen en "0-9").
  const opcionesArticulos = useMemo(() => {
    return [...articulos]
      .map((a) => {
        const codigo = String(a.codigo ?? "");
        const primera = (codigo[0] || "#").toUpperCase();
        return {
          ...a,
          firstLetter: /[0-9]/.test(primera) ? "0-9" : primera,
        };
      })
      .sort((a, b) =>
        String(a.codigo ?? "").localeCompare(String(b.codigo ?? ""), undefined, {
          numeric: true,
          sensitivity: "base",
        })
      );
  }, [articulos]);
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 5000000;

  // Orden compartido por la tabla, el PDF y los dos Excel: manda la columna
  // que el usuario escogio en el encabezado y los empates (p. ej. todas las
  // filas de la misma familia) se desempatan por familia -> coleccion ->
  // codigo. Asi lo exportado sale exactamente en el orden que se ve en
  // pantalla, agrupado por familia y temporada.
  const CAMPOS_NUMERICOS = [
    "cantidad",
    "piezasPorCaja",
    "cajas",
    "venta",
    "venta2",
    "venta3",
    "venta4",
    "disponible",
  ];

  // "disponible" es calculado, no viene en el registro.
  const valorOrden = (row, campo) =>
    campo === "disponible" ? calculaDisponible(row) : row[campo];

  const comparaTexto = (a, b) =>
    String(a ?? "").localeCompare(String(b ?? ""), undefined, {
      numeric: true,
      sensitivity: "base",
    });

  const ordenVista = (a, b) => {
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      const va = valorOrden(a, sorting.field);
      const vb = valorOrden(b, sorting.field);
      const dif = CAMPOS_NUMERICOS.includes(sorting.field)
        ? (parseFloat(va) || 0) - (parseFloat(vb) || 0)
        : comparaTexto(va, vb);
      if (dif !== 0) return reversed * dif;
    }
    return (
      comparaTexto(a.familia, b.familia) ||
      comparaTexto(a.coleccion, b.coleccion) ||
      comparaTexto(a.codigo, b.codigo)
    );
  };

  let hoy = new Date();
  hoy.setDate(hoy.getDate() - 3650);
  const year = hoy.getFullYear();
  const years = Array.from(new Array(12), (val, index) => index + year);

  useEffect(() => {
    axios
      .get(`${URL_INVENTARIOS}Acumulado`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allInventarios = response.data;
        // Array para pagination
        let arrayTabla = allInventarios
          .sort((a, b) => (a.nombre > b.nombre ? 1 : -1))
          .map((a) => {
            // if(a.cantidad >0){
            // if(
            //   (user.areas == AREAS_GENERAL)
            //   ){
            return {
              _id: a._id,
              activo: a.activo,
              cantidad: a.cantidad,
              codigo: a.codigo,
              codigoCliente: a.codigoCliente,
              nombre: a.nombre,
              idArticulo: a.idArticulo,
              costoUSD: a.costoUSD,
              costoMX: a.costoMX,
              venta: a.venta,
              venta2: a.venta2 || 0,
              venta3: a.venta3 || 0,
              venta4: a.venta4 || 0,
              observaciones: a.observaciones,
              idCompras: a.idCompras,
              piezasPorCaja: a.piezasPorCaja,
              linea: a.linea,
              idLinea: a.idLinea,
              marca: a.marca,
              idMarca: a.idMarca,
              familia: a.familia,
              idFamilia: a.idFamilia,
              coleccion: a.coleccion,
              idColeccion: a.idColeccion,
              proveedor: a.proveedor,
              idProveedor: a.idProveedor,
              cajas: (a.cantidad / a.piezasPorCaja).toFixed(2),
              area: a.area,
              idArea: a.idArea,
              urlFoto: a.urlFoto,
              ano: a.ano,
              tipo: a.tipo
            }
          // } else if(user.areas == a.idArea){
          //  return {
          //   _id: a._id,
          //   activo: a.activo,
          //   cantidad: a.cantidad,
          //   codigo: a.codigo,
          //   nombre: a.nombre,
          //   idArticulo: a.idArticulo,
          //   costoUSD: a.costoUSD,
          //   costoMX: a.costoMX,
          //   venta: a.venta,
          //   observaciones: a.observaciones,
          //   idCompras: a.idCompras,
          //   piezasPorCaja: a.piezasPorCaja,
          //   linea: a.linea,
          //   idLinea: a.idLinea,
          //   marca: a.marca,
          //   idMarca: a.idMarca,
          //   familia: a.familia,
          //   idFamilia: a.idFamilia,
          //   coleccion: a.coleccion,
          //   idColeccion: a.idColeccion,
          //   proveedor: a.proveedor,
          //   idProveedor: a.idProveedor,
          //   cajas: (a.cantidad / a.piezasPorCaja).toFixed(2),
          //   area: a.area,
          //   idArea: a.idArea,
          //   urlFoto: a.urlFoto,
          //   ano: a.ano
          //  }
          // }
        // }
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setComments(dataFinal);

        let can = dataFinal.map((c) => parseFloat(c.cantidad));
        let TCan = can.reduce((t, cantidad, index) => t + cantidad, 0);
        setTotalTotal(TCan);

        let caj = dataFinal.map((c) => parseFloat(c.cajas));
        let Tcaj = caj.reduce((t, cajas, index) => t + cajas, 0);
        setTotalTotalCajas(Tcaj);
      
      })
      .catch((err) => {
        console.log(err);
      });

    // Pendiente de surtir por articulo (solo pedidos abiertos y activos)
    axios
      .get(`${URL_INVENTARIOS}PendienteSurtirArticulos`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        const mapa = {};
        (response.data || []).forEach((r) => {
          mapa[String(r._id)] = parseFloat(r.pendiente) || 0;
        });
        setPendientePorArticulo(mapa);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_LINEAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allLineas = response.data;
        setLineas(allLineas);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allMarcas = response.data;
        setMarcas(allMarcas);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(URL_FAMILIAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allFamilias = response.data;
        setFamilias(allFamilias);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLECCIONES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColecciones = response.data;
        setColecciones(allColecciones);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_ARTICULOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulos = response.data;
        setArticulos(allArticulos);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
      .get(URL_AREAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allAreas = response.data;
        setAreas(allAreas);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);



  function PDFTabla(listas = [1], incluirCedis = false) {
    // listas es un array de numeros (1..4); generamos una columna por cada lista seleccionada.
    const ventaKey = (n) => `venta${n === 1 ? "" : n}`;

    let total_general = 0;
    let total_cajas = 0;
    // Total en dinero acumulado por cada lista seleccionada.
    // Si incluirCedis, la cantidad para multiplicar es (visible + CEDIS).
    const totalDinero = listas.map(() => 0);
    // Agrupamos por articulo + area para que el filtro por almacen funcione
    // (igual que excel/enviaMail). Si solo agrupamos por idArticulo, varias
    // areas se colapsan en una sola fila y el idArea final es el del ultimo
    // registro procesado.
    let agrupado = comments.reduce(function (groups, item) {
      const val = item["idArticulo"] + item["idArea"];
      groups[val] = groups[val] || {
        idArticulo: item.idArticulo,
        cantidad: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val]._id = item._id;
      groups[val].activo = item.activo;
      groups[val].nombre = item.nombre;
      groups[val].codigo = item.codigo;
      groups[val].codigoCliente = item.codigoCliente;
      groups[val].idArticulo = item.idArticulo;
      groups[val].costoUSD = item.costoUSD;
      groups[val].costoMX = item.costoMX;
      groups[val].venta = item.venta;
      groups[val].venta2 = item.venta2 || 0;
      groups[val].venta3 = item.venta3 || 0;
      groups[val].venta4 = item.venta4 || 0;
      groups[val].observaciones = item.observaciones;
      groups[val].idCompras = item.idCompras;
      groups[val].piezasPorCaja = item.piezasPorCaja;
      groups[val].linea = item.linea;
      groups[val].idLinea = item.idLinea;
      groups[val].marca = item.marca;
      groups[val].idMarca = item.idMarca;
      groups[val].familia = item.familia;
      groups[val].idFamilia = item.idFamilia;
      groups[val].coleccion = item.coleccion;
      groups[val].idColeccion = item.idColeccion;
      groups[val].proveedor = item.proveedor;
      groups[val].idProveedor = item.idProveedor;
      groups[val].area = item.area;
      groups[val].idArea = item.idArea;
      groups[val].cajas = item.cajas;
      groups[val].urlFoto = item.urlFoto;
      groups[val].ano = item.ano;
      groups[val].tipo = item.tipo;
      return groups;
    },[])

    let computedComments = Object.values(agrupado);

    // Si incluir CEDIS, construimos un map por idArticulo con la cantidad/cajas
    // del registro en CEDIS.
    const cedisMap = new Map();
    if (incluirCedis) {
      computedComments.forEach((c) => {
        if (String(c.idArea) === String(AREAS_CEDIS)) {
          cedisMap.set(String(c.idArticulo), {
            cantidad: parseFloat(c.cantidad) || 0,
            cajas: parseFloat(c.cajas) || 0,
          });
        }
      });
    }

    const data = computedComments
    .filter(
      (comment) =>
        String(comment.codigo ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.codigoCliente ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.tipo ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.coleccion ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.ano ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.area ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.idArea ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.idArticulo ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.cajas ?? "").includes(search) ||
        String(comment.cantidad ?? "").includes(search) ||
        String(comment.piezasPorCaja ?? "").includes(search)
    )
      .sort(ordenVista)
      .map((a) => {
        if (
          (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
          (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
          (selectedTipoFiltro == 0 || selectedTipoFiltro == a.tipo) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) &&
          (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
          (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
          (selectedAno == 0 || selectedAno == a.ano) &&
          (selectedArea == 0 || selectedArea == a.idArea) &&
          (activo == 0 || activo == a.is_active) &&
      (filtroCantidad === "" ||
        (filtroCantidad === "ConCantidad"
          ? parseFloat(a.cantidad) > 0
          : !(parseFloat(a.cantidad) > 0))) &&
      pasaRangoCantidad(a.cantidad) &&
        (filtroCantidad === "" ||
          (filtroCantidad === "ConCantidad"
            ? parseFloat(a.cantidad) > 0
            : !(parseFloat(a.cantidad) > 0))) &&
        pasaRangoCantidad(a.cantidad) &&
          (filtroCantidad === "" ||
            (filtroCantidad === "ConCantidad"
              ? parseFloat(a.cantidad) > 0
              : !(parseFloat(a.cantidad) > 0))) &&
          pasaRangoCantidad(a.cantidad)
        ) {
          // Si la fila NO es CEDIS, intentamos jalar su cantidad de CEDIS
          // (cuando el usuario eligio incluirCedis).
          const esRowCedis = String(a.idArea) === String(AREAS_CEDIS);
          const cedisInfo = incluirCedis && !esRowCedis
            ? cedisMap.get(String(a.idArticulo)) || { cantidad: 0, cajas: 0 }
            : { cantidad: 0, cajas: 0 };

          total_general = parseFloat(total_general) + parseFloat(a.cantidad) + cedisInfo.cantidad;
          total_cajas = parseFloat(total_cajas) + parseFloat(a.cajas) + cedisInfo.cajas;

          let foto = a.urlFoto === "No"
          ? process.env.PUBLIC_URL + "sinImagen.png"
          : a.urlFoto;

          const preciosCols = listas.map((n) =>
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(parseFloat(a[ventaKey(n)]) || 0)
          );
          // El total entre parentesis = cantidad de la fila visible + CEDIS,
          // o sea lo mismo que se suma al total_general de esta fila.
          const totalSumado = parseFloat(a.cantidad) + cedisInfo.cantidad;
          const cedisCol = incluirCedis
            ? [
                `${new Intl.NumberFormat("en-US").format(
                  cedisInfo.cantidad
                )} (${new Intl.NumberFormat("en-US").format(totalSumado)})`,
              ]
            : [];

          // Acumulamos el total en dinero por lista: si se incluye CEDIS
          // usamos la cantidad sumada (visible + CEDIS), si no, solo la visible.
          const cantidadParaDinero = incluirCedis
            ? totalSumado
            : parseFloat(a.cantidad) || 0;
          listas.forEach((n, idx) => {
            totalDinero[idx] +=
              cantidadParaDinero * (parseFloat(a[ventaKey(n)]) || 0);
          });
          return [
            foto,
            a.codigo,
            a.codigoCliente,
            a.nombre,
            new Intl.NumberFormat("en-US").format(a.cantidad),
            new Intl.NumberFormat("en-US").format(calculaDisponible(a)),
            ...cedisCol,
            ...preciosCols,
            a.area,
          ];
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 30);
    const listasTexto = listas.map((n) => `Lista ${n}`).join(", ");
    doc.text(`Listado Inventarios - ${listasTexto}`, 20, 40);
    doc.setFontSize(8)
    doc.autoTable({
      head: [
        [
          "",
          "Codigo",
          "Codigo Cliente",
          "Nombre",
          "Cantidad",
          "Disponible",
          ...(incluirCedis ? ["CEDIS"] : []),
          ...listas.map((n) => `Lista ${n}`),
          "Almacen",
        ],
      ],
      body: dataPDFLimpia,
      columnStyles: [
        { fontSize: .000001, textColor: [255, 255, 255], cellWidth: 20 },
      ],
 headStyles: {
            fillColor: ["#f28029"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#f28029"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "Totales",
          // Si incluimos CEDIS, el total cantidad se corre a la columna CEDIS
          // (queda debajo de las cantidades con formato "cedis (visible+cedis)").
          incluirCedis
            ? ""
            : new Intl.NumberFormat("en-US").format(total_general),
          "", // columna Disponible
          ...(incluirCedis
            ? [new Intl.NumberFormat("en-US").format(total_general)]
            : []),
          ...totalDinero.map((t) =>
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(t)
          ),
          "",
        ],
      ],
      showFoot: "lastPage",
      styles: {
        minCellHeight: 20, // Ajusta la altura mínima de las filas
        cellPadding: 5,    // Ajusta el padding de las celdas para dar más espacio
        fontSize: 8
      },
      didDrawCell: function (data) {
        if (data.column.index === 0 && data.cell.section === 'body') {
          var td = data.cell.raw;
          var img = td;
          var textPos = data.cell;
          doc.addImage(img, textPos.x, textPos.y, 20, 20);
        }}
    });
    // Blob URL: maneja PDFs grandes sin el limite de los data URL y
    // suele pasar mejor por el popup blocker que dataurlnewwindow.
    const blobUrl = URL.createObjectURL(doc.output("blob"));
    window.open(blobUrl, "_blank");
  }

  async function PromptListaParaPDF() {
    const { value: result } = await Swal.fire({
      title: "Configurar PDF",
      html: `
        <div style="text-align: left; padding: 0 20px;">
          <p style="font-weight: bold; margin: 8px 0;">Listas de precios:</p>
          <label style="display:block; margin: 8px 0;"><input type="checkbox" id="swal-l1" checked /> Lista Milano</label>
          <label style="display:block; margin: 8px 0;"><input type="checkbox" id="swal-l2" /> Lista 2</label>
          <label style="display:block; margin: 8px 0;"><input type="checkbox" id="swal-l3" /> Lista 3</label>
          <label style="display:block; margin: 8px 0;"><input type="checkbox" id="swal-l4" /> Lista 4</label>
          <hr style="margin: 12px 0;" />
          <label style="display:block; margin: 8px 0;"><input type="checkbox" id="swal-cedis" /> Incluir inventario de CEDIS</label>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Generar PDF",
      cancelButtonText: "Cancelar",
      preConfirm: () => {
        const selected = [];
        if (document.getElementById("swal-l1").checked) selected.push(1);
        if (document.getElementById("swal-l2").checked) selected.push(2);
        if (document.getElementById("swal-l3").checked) selected.push(3);
        if (document.getElementById("swal-l4").checked) selected.push(4);
        const incluirCedis = document.getElementById("swal-cedis").checked;
        if (selected.length === 0) {
          Swal.showValidationMessage("Selecciona al menos una lista");
          return false;
        }
        return { listas: selected, incluirCedis };
      },
    });
    if (result && result.listas.length) PDFTabla(result.listas, result.incluirCedis);
  }

  async function PromptExcel() {
    const { value: result } = await Swal.fire({
      title: "Configurar Excel",
      html: `
        <div style="text-align: left; padding: 0 20px;">
          <label style="display:block; margin: 8px 0;"><input type="checkbox" id="swal-excel-cedis" /> Incluir inventario de CEDIS</label>
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Descargar Excel",
      cancelButtonText: "Cancelar",
      preConfirm: () => ({
        incluirCedis: document.getElementById("swal-excel-cedis").checked,
      }),
    });
    if (result) excel(result.incluirCedis);
  }

// incluirCedis: igual que en PDFTabla, a cada fila que no es de CEDIS se le
// agrega lo que hay de ese articulo en CEDIS, y el total en dinero se calcula
// con (cantidad + CEDIS).
function excel(incluirCedis = false) {
  let total_general = 0;
  let total_cajas = 0;
  let total_total = 0; // 👈 nuevo
  let total_cedis = 0;
  let total_con_cedis = 0;

  const toNum = (v) => {
    if (v === null || v === undefined || v === "") return 0;
    const n = Number(String(v).replace(/[$,\s]/g, ""));
    return Number.isFinite(n) ? n : 0;
  };

  let agrupado = comments.reduce(function (groups, item) {
    const val = item["idArticulo"] + item["idArea"];
    groups[val] = groups[val] || { idArticulo: item.idArticulo, cantidad: 0 };

    groups[val].cantidad += toNum(item.cantidad);
    Object.assign(groups[val], item);

    return groups;
  }, []);

  let computedComments = Object.values(agrupado);

  // Cantidad en CEDIS por articulo (se arma antes de filtrar, como en el PDF).
  const cedisMap = new Map();
  if (incluirCedis) {
    computedComments.forEach((c) => {
      if (String(c.idArea) === String(AREAS_CEDIS)) {
        cedisMap.set(String(c.idArticulo), toNum(c.cantidad));
      }
    });
  }

  const data = computedComments
    .filter((comment) =>
      String(comment.codigo ?? "").toLowerCase().includes(search.toLowerCase()) ||
      String(comment.codigoCliente ?? "").toLowerCase().includes(search.toLowerCase()) ||
      String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
      String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
      String(comment.tipo ?? "").toLowerCase().includes(search.toLowerCase()) ||
      String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
      String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
      String(comment.coleccion ?? "").toLowerCase().includes(search.toLowerCase()) ||
      String(comment.ano ?? "").toLowerCase().includes(search.toLowerCase()) ||
      String(comment.area ?? "").toLowerCase().includes(search.toLowerCase()) ||
      String(comment.idArea ?? "").toLowerCase().includes(search.toLowerCase()) ||
      String(comment.cajas ?? "").includes(search) ||
      String(comment.cantidad ?? "").includes(search) ||
      String(comment.piezasPorCaja ?? "").includes(search)
    )
    .sort(ordenVista)
    .map((a) => {
      if (
        (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
        (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
        (selectedTipoFiltro == 0 || selectedTipoFiltro == a.tipo) &&
        (selectedMarca == 0 || selectedMarca == a.idMarca) &&
        (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
        (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
        (selectedAno == 0 || selectedAno == a.ano) &&
        (selectedArea == 0 || selectedArea == a.idArea) &&
        (activo == 0 || activo == a.is_active) &&
      (filtroCantidad === "" ||
        (filtroCantidad === "ConCantidad"
          ? parseFloat(a.cantidad) > 0
          : !(parseFloat(a.cantidad) > 0))) &&
      pasaRangoCantidad(a.cantidad) &&
        (filtroCantidad === "" ||
          (filtroCantidad === "ConCantidad"
            ? parseFloat(a.cantidad) > 0
            : !(parseFloat(a.cantidad) > 0))) &&
        pasaRangoCantidad(a.cantidad)
      ) {
        const cantidadInt = Math.round(toNum(a.cantidad));
        const ventaNum = toNum(a.venta);
        // La fila de CEDIS no se suma a si misma.
        const esRowCedis = String(a.idArea) === String(AREAS_CEDIS);
        const cedisCant =
          incluirCedis && !esRowCedis
            ? Math.round(cedisMap.get(String(a.idArticulo)) || 0)
            : 0;
        const cantidadConCedis = cantidadInt + cedisCant;
        const totalFila = (incluirCedis ? cantidadConCedis : cantidadInt) * ventaNum;

        total_general += cantidadInt;
        total_cajas += toNum(a.cajas);
        total_total += totalFila;
        total_cedis += cedisCant;
        total_con_cedis += cantidadConCedis;

        return {
          idArticulo: a.idArticulo,
          idInv: a._id,
          Marca: a.marca,
          Tipo: a.tipo,
          Codigo: a.codigo,
          CodigoCliente: a.codigoCliente,
          Nombre: a.nombre,
          Familia: a.familia,
          Linea: a.linea,
          Coleccion: a.coleccion,
          Ano: a.ano,
          Proveedor: a.proveedor,
          PiezasPorCaja: Math.round(toNum(a.piezasPorCaja)), // entero
          Cajas: toNum(a.cajas), // puede decimal
          Cantidad: cantidadInt, // entero
          Disponible: Math.round(calculaDisponible(a)),
          CEDIS: cedisCant,
          "Cantidad + CEDIS": cantidadConCedis,
          Venta: ventaNum,       // pesos
          Total: totalFila,      // 👈 nuevo
          Almacen: a.area,
        };
      }
    })
    .filter(Boolean);

  const columnas = [
    "idArticulo",
    "idInv",
    "Marca",
    "Tipo",
    "Codigo",
    "CodigoCliente",
    "Nombre",
    "Familia",
    "Linea",
    "Coleccion",
    "Ano",
    "Proveedor",
    "PiezasPorCaja",
    "Cajas",
    "Cantidad",
    "Disponible",
    ...(incluirCedis ? ["CEDIS", "Cantidad + CEDIS"] : []),
    "Venta",
    "Total",     // 👈 nuevo (después de Venta)
    "Almacen",
  ];

  const dataOrdenada = data.map((row) => {
    let nuevo = {};
    columnas.forEach((col) => (nuevo[col] = row[col]));
    return nuevo;
  });

  const worksheet = XLSX.utils.json_to_sheet(dataOrdenada, { header: columnas });

  // ===== estilos header =====
  const range0 = XLSX.utils.decode_range(worksheet["!ref"]);
  const headerStyle = {
    fill: { fgColor: { rgb: "D9E1F2" } },
    font: { bold: true },
    alignment: { horizontal: "center", vertical: "center" },
  };

  for (let col = range0.s.c; col <= range0.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: 0, c: col });
    if (worksheet[cellAddress]) worksheet[cellAddress].s = headerStyle;
  }

  worksheet["!autofilter"] = {
    ref: XLSX.utils.encode_range({
      s: { r: 0, c: range0.s.c },
      e: { r: 0, c: range0.e.c },
    }),
  };

  const colIndex = (name) => columnas.indexOf(name);

  const idxPiezas = colIndex("PiezasPorCaja");
  const idxCajas = colIndex("Cajas");
  const idxCant = colIndex("Cantidad");
  const idxVenta = colIndex("Venta");
  const idxTotal = colIndex("Total"); // 👈 nuevo
  const idxCedis = colIndex("CEDIS");
  const idxConCedis = colIndex("Cantidad + CEDIS");

  const intStyle = { numFmt: "0" };      // enteros
  const decStyle = { numFmt: "0.00" };   // decimales (cajas)
  const mxnStyle = { numFmt: '$#,##0.00;[Red]-$#,##0.00' }; // pesos
  const boldStyle = { font: { bold: true } };

  // ===== formatos numéricos filas =====
  let range = XLSX.utils.decode_range(worksheet["!ref"]);
  for (let r = 1; r <= range.e.r; r++) {
    const setCellNum = (c, style) => {
      const addr = XLSX.utils.encode_cell({ r, c });
      const cell = worksheet[addr];
      if (!cell) return;
      cell.t = "n";
      cell.s = { ...(cell.s || {}), ...style };
    };

    if (idxPiezas >= 0) setCellNum(idxPiezas, intStyle);
    if (idxCajas >= 0) setCellNum(idxCajas, decStyle);
    if (idxCant >= 0) setCellNum(idxCant, intStyle);
    if (idxVenta >= 0) setCellNum(idxVenta, mxnStyle);
    if (idxTotal >= 0) setCellNum(idxTotal, mxnStyle); // 👈 nuevo
    if (idxCedis >= 0) setCellNum(idxCedis, intStyle);
    if (idxConCedis >= 0) setCellNum(idxConCedis, intStyle);
  }

  // ===== fila de totales al final =====
  const totalRowIndex = range.e.r + 1; // siguiente fila disponible
  const totRow = new Array(columnas.length).fill("");

  // pon un label en la primera columna (o cámbialo a la que prefieras)
  totRow[0] = "TOTALES";

  if (idxCajas >= 0) totRow[idxCajas] = total_cajas;
  if (idxCant >= 0) totRow[idxCant] = total_general;
  if (idxTotal >= 0) totRow[idxTotal] = total_total;
  if (idxCedis >= 0) totRow[idxCedis] = total_cedis;
  if (idxConCedis >= 0) totRow[idxConCedis] = total_con_cedis;

  XLSX.utils.sheet_add_aoa(worksheet, [totRow], { origin: { r: totalRowIndex, c: 0 } });

  // actualiza rango
  range = XLSX.utils.decode_range(worksheet["!ref"]);

  // aplica estilos a la fila de totales
  const setCell = (r, c, style, forceNum = false) => {
    const addr = XLSX.utils.encode_cell({ r, c });
    const cell = worksheet[addr];
    if (!cell) return;
    if (forceNum) cell.t = "n";
    cell.s = { ...(cell.s || {}), ...style };
  };

  // negritas a toda la fila
  for (let c = range.s.c; c <= range.e.c; c++) {
    setCell(totalRowIndex, c, boldStyle);
  }
  if (idxCajas >= 0) setCell(totalRowIndex, idxCajas, { ...boldStyle, ...decStyle }, true);
  if (idxCant >= 0) setCell(totalRowIndex, idxCant, { ...boldStyle, ...intStyle }, true);
  if (idxTotal >= 0) setCell(totalRowIndex, idxTotal, { ...boldStyle, ...mxnStyle }, true);
  if (idxCedis >= 0) setCell(totalRowIndex, idxCedis, { ...boldStyle, ...intStyle }, true);
  if (idxConCedis >= 0) setCell(totalRowIndex, idxConCedis, { ...boldStyle, ...intStyle }, true);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "ListadoInventarios");
  XLSX.writeFile(workbook, "ListadoInventarios.xlsx");
}



// Convertir Blob a base64
function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result.split(",")[1];
      resolve(base64String);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

async function excelConImagenes() {
  const agrupado = comments.reduce((groups, item) => {
    const key = item["idArticulo"] + item["idArea"];
    groups[key] = groups[key] || { ...item, cantidad: 0 };
    groups[key].cantidad += item.cantidad;
    return groups;
  }, {});

  const filtrados = Object.values(agrupado).filter((a) => {
    return (
      (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
      (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
      (selectedTipoFiltro == 0 || selectedTipoFiltro == a.tipo) &&
      (selectedMarca == 0 || selectedMarca == a.idMarca) &&
      (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
      (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
      (selectedAno == 0 || selectedAno == a.ano) &&
      (selectedArea == 0 || selectedArea == a.idArea) &&
      (activo == 0 || activo == a.is_active) &&
      (filtroCantidad === "" ||
        (filtroCantidad === "ConCantidad"
          ? parseFloat(a.cantidad) > 0
          : !(parseFloat(a.cantidad) > 0))) &&
      pasaRangoCantidad(a.cantidad)
    );
  });

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet("ListadoInventarios");

  // Encabezados
  const headers = [
    "Foto", "Código", "Código Cliente", "Nombre", "Línea", "Marca", "Familia", "Colección", "Año",
    "Pzs x Caja", "Cajas", "Cantidad", "Venta", "Almacén"
  ];
  sheet.addRow(headers);
  sheet.getRow(1).font = { bold: true };

  sheet.columns = [
    { width: 15 }, { width: 15 }, { width: 30 }, { width: 15 }, { width: 15 },
    { width: 15 }, { width: 15 }, { width: 10 }, { width: 12 },
    { width: 10 }, { width: 10 }, { width: 10 }, { width: 15 },
  ];

  for (let i = 0; i < filtrados.length; i++) {
    const item = filtrados[i];
    const rowIdx = i + 2;

    sheet.addRow([
      "", // imagen va aquí
      item.codigo,
      item.codigoCliente,
      item.nombre,
      item.tipo,
      item.linea,
      item.marca,
      item.familia,
      item.coleccion,
      item.ano,
      item.piezasPorCaja,
      item.cajas,
      item.cantidad,
      item.venta,
      item.area,
    ]);

    sheet.getRow(rowIdx).height = 40;

    let imageUrl = null;

    // if (item.fotoArticulo === "Si") {
      try {
        const res = await fetch(`${process.env.REACT_APP_URL_GETMEDIA}/${item.idArticulo}`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("app_token")}`,
          },
        });

        const data = await res.json();

        if (data.secure_url) {
          imageUrl = data.secure_url;
        } else {
          console.warn(`No se encontró secure_url para ${item.codigo}`);
          continue;
        }
      } catch (err) {
        console.warn(`Error obteniendo imagen para ${item.codigo}`, err);
        continue;
      }
    // } else {
    //   console.warn(`Sin imagen para ${item.codigo}`);
    //   continue;
    // }

    try {
      const blob = await fetch(imageUrl).then((r) => r.blob());

      const extension = blob.type.includes("jpeg") ? "jpeg"
                      : blob.type.includes("png") ? "png"
                      : blob.type.includes("gif") ? "gif"
                      : null;

      if (!extension) {
        console.warn(`Formato no compatible para ${item.codigo}: ${blob.type}`);
        continue;
      }

      const base64 = await blobToBase64(blob);

      const imageId = workbook.addImage({
        base64,
        extension,
      });

      sheet.addImage(imageId, {
        tl: { col: 0, row: rowIdx - 1 },
        ext: { width: 60, height: 60 },
      });
    } catch (e) {
      console.warn(`Error al insertar imagen para ${item.codigo}`, e);
    }
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, "ListadoInventariosConFotos.xlsx");
}

function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

  function enviaMail() {
    let total_general = 0;
    let total_cajas = 0;
    let agrupado = comments.reduce(function (groups, item) {
      const val = item["idArticulo"] + item["idArea"];
      groups[val] = groups[val] || {
        idArticulo: item.idArticulo,
        cantidad: 0,
      };
      groups[val].cantidad += item.cantidad;
      groups[val]._id = item._id;
      groups[val].activo = item.activo;
      groups[val].nombre = item.nombre;
      groups[val].codigo = item.codigo;
      groups[val].codigoCliente = item.codigoCliente;
      groups[val].idArticulo = item.idArticulo;
      groups[val].costoUSD = item.costoUSD;
      groups[val].costoMX = item.costoMX;
      groups[val].venta = item.venta;
      groups[val].venta2 = item.venta2 || 0;
      groups[val].venta3 = item.venta3 || 0;
      groups[val].venta4 = item.venta4 || 0;
      groups[val].observaciones = item.observaciones;
      groups[val].idCompras = item.idCompras;
      groups[val].piezasPorCaja = item.piezasPorCaja;
      groups[val].linea = item.linea;
      groups[val].idLinea = item.idLinea;
      groups[val].marca = item.marca;
      groups[val].idMarca = item.idMarca;
      groups[val].familia = item.familia;
      groups[val].idFamilia = item.idFamilia;
      groups[val].coleccion = item.coleccion;
      groups[val].idColeccion = item.idColeccion;
      groups[val].proveedor = item.proveedor;
      groups[val].idProveedor = item.idProveedor;
      groups[val].area = item.area;
      groups[val].idArea = item.idArea;
      groups[val].cajas = item.cajas;
      groups[val].ano = item.ano;
      groups[val].tipo = item.tipo;
      return groups;
    },[])

    let computedComments = Object.values(agrupado);

    const data = computedComments
    .filter(
      (comment) =>
        String(comment.codigo ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.codigoCliente ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.tipo ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.coleccion ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.ano ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.area ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.idArea ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.idArticulo ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.cajas ?? "").includes(search) ||
        String(comment.cantidad ?? "").includes(search) ||
        String(comment.piezasPorCaja ?? "").includes(search)
    )
      .sort(ordenVista)
      .map((a) => {
        if (
          (selectedArticulo == 0 || selectedArticulo == a.idArticulo) &&
          (selectedLineaFiltro == 0 || selectedLineaFiltro == a.idLinea) &&
          (selectedTipoFiltro == 0 || selectedTipoFiltro == a.idTipo) &&
          (selectedMarca == 0 || selectedMarca == a.idMarca) &&
          (selectedFamiliaFiltro == 0 || selectedFamiliaFiltro == a.idFamilia) &&
          (selectedColeccion == 0 || selectedColeccion == a.idColeccion) &&
          (selectedAno == 0 || selectedAno == a.ano) &&
          (selectedArea == 0 || selectedArea == a.idArea) &&
          (activo == 0 || activo == a.is_active) &&
      (filtroCantidad === "" ||
        (filtroCantidad === "ConCantidad"
          ? parseFloat(a.cantidad) > 0
          : !(parseFloat(a.cantidad) > 0))) &&
      pasaRangoCantidad(a.cantidad) &&
        (filtroCantidad === "" ||
          (filtroCantidad === "ConCantidad"
            ? parseFloat(a.cantidad) > 0
            : !(parseFloat(a.cantidad) > 0))) &&
        pasaRangoCantidad(a.cantidad) &&
          (filtroCantidad === "" ||
            (filtroCantidad === "ConCantidad"
              ? parseFloat(a.cantidad) > 0
              : !(parseFloat(a.cantidad) > 0))) &&
          pasaRangoCantidad(a.cantidad)
        ) {
          total_general = parseFloat(total_general) + parseFloat(a.cantidad)
          total_cajas = parseFloat(total_cajas) + parseFloat(a.cajas)
          return [
            a.codigo,
            a.codigoCliente,
            a.nombre,
            a.tipo,
            a.linea,
            a.marca,
            a.familia,
            a.coleccion,
            a.ano,
            a.piezasPorCaja,
            new Intl.NumberFormat("en-US").format(a.cajas),
            new Intl.NumberFormat("en-US").format(a.cantidad),
            a.area
          ];
        }
      });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 120, 10, 35, 30);
    doc.text(`Listado Inventarios`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Codigo",
          "Codigo Cliente",
          "Nombre",
          "Tipo",
          "Linea",
          "Marca",
          "Familia",
          "Coleccion",
          "Ano",
          "PxC",
          "Cajas",
          "Cantidad",
          "Almacen",

        ],
      ],
      body: dataPDFLimpia,
 headStyles: {
            fillColor: ["#f28029"],
            lineWidth: 0
          },
          footStyles: {
            fillColor: ["#f28029"],
          },
          theme:"grid",
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "",
          "Totales",
          new Intl.NumberFormat("en-US").format(total_cajas),
          new Intl.NumberFormat("en-US").format(total_general),
        ],
      ],
      showFoot: "lastPage",
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Inventarios",
          email: mailTo,
          fileName: "ListadoInventarios.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Inventarios.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

 

  const headers = [
    { name: "Codigo", field: "codigo", sortable: true },
    { name: "Codigo Cliente", field: "codigoCliente", sortable: true },
    { name: "Nombre", field: "nombre", sortable: true },
    { name: "Familia", field: "familia", sortable: true },
    { name: "Coleccion", field: "coleccion", sortable: true },
    {
      name: `Lista ${listaPrecio}`,
      field: listaPrecio === "1" ? "venta" : `venta${listaPrecio}`,
      sortable: true,
    },
    { name: "Cantidad", field: "cantidad", sortable: true },
    { name: "Disponible", field: "disponible", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Ficha Tecnica", field: "foto", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          String(comment.codigo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.codigoCliente ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.nombre ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.linea ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.tipo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.marca ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.familia ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.coleccion ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.ano ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.area ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.idArea ?? "").toLowerCase().includes(search.toLowerCase()) ||
        String(comment.idArticulo ?? "").toLowerCase().includes(search.toLowerCase()) ||
          String(comment.cajas ?? "").includes(search) ||
          String(comment.cantidad ?? "").includes(search) ||
          String(comment.venta ?? "").includes(search) ||
          String(comment.piezasPorCaja ?? "").includes(search)
      );
    }

    if (selectedLineaFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idLinea.includes(selectedLineaFiltro)
      );
    }

        if (selectedTipoFiltro) {
      computedComments = computedComments.filter((e) =>
        e.tipo.includes(selectedTipoFiltro)
      );
    }

    if (activo) {
      computedComments = computedComments.filter((e) =>
        e.activo.includes(activo)
      );
    }
    if (selectedMarca) {
      computedComments = computedComments.filter((e) =>
        e.idMarca.includes(selectedMarca)
      );
    }
    if (selectedArticulo) {
      computedComments = computedComments.filter((e) =>
        e.idArticulo.includes(selectedArticulo)
      );
    }
    if (selectedFamiliaFiltro) {
      computedComments = computedComments.filter((e) =>
        e.idFamilia.includes(selectedFamiliaFiltro)
      );
    }
    if (selectedColeccion) {
      computedComments = computedComments.filter((e) =>
        e.idColeccion.includes(selectedColeccion)
      );
    }
    if (selectedAno) {
      computedComments = computedComments.filter((e) =>
        e.ano.includes(selectedAno)
      );
    }
    if (selectedArea) {
      computedComments = computedComments.filter((e) =>
        e.idArea.includes(selectedArea)
      );
    }

    if (filtroCantidad === "ConCantidad") {
      computedComments = computedComments.filter(
        (e) => parseFloat(e.cantidad) > 0
      );
    } else if (filtroCantidad === "En0") {
      computedComments = computedComments.filter(
        (e) => !(parseFloat(e.cantidad) > 0)
      );
    }

    // Rango mayor/menor que. Las filas en 0 no participan: si hay rango
    // activo, se excluyen para no ensuciar el resultado.
    computedComments = computedComments.filter((e) =>
      pasaRangoCantidad(e.cantidad)
    );

    setTotalItems(computedComments.length);

    // Mismo orden que usan el PDF y los Excel (ver ordenVista). Se ordena
    // sobre una copia para no mutar el arreglo de estado.
    computedComments = [...computedComments].sort(ordenVista);

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedArticulo,
    activo,
    selectedLineaFiltro,
    selectedTipoFiltro,
    selectedMarca, 
    selectedFamiliaFiltro, 
    selectedColeccion,
    selectedAno,
    selectedArea,
    filtroCantidad,
    cantidadMayorQue,
    cantidadMenorQue,
    listaPrecio,
    // El orden por "Disponible" depende del pendiente de surtir.
    pendientePorArticulo,
  ]);


  function limpiarSearch(){
    setSearch("")
    setSelectedArticulo("")
    setSelectedLineaFiltro("")
    setSelectedTipoFiltro("")
    setSelectedMarca("")
    setSelectedFamiliaFiltro("")
    setSelectedColeccion("")
    setSelectedAno("")
    setSelectedArea("")
    setFiltroCantidad("")
    setCantidadMayorQue("")
    setCantidadMenorQue("")
  }

  
  function jalaFoto(
    idEdit
  ) {
    setPhoto("")
    const URL_GET_MEDIA = `${process.env.REACT_APP_URL_GETMEDIA}/${idEdit}`;
    axios
      .get(URL_GET_MEDIA, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((data) => {
        if (data.data.version) {
          setPhoto(data.data.version);
        }
      })
      .catch((err) => console.log(err));


    setIdEditArticulo(idEdit);
    toggleFoto();
  }

  function tablaColores(idEdit) {
  setArrayColores([]);
  axios
    .get(`${URL_ARTICULOS_PROPORCION}Articulos/${idEdit}`, {
      headers: {
        Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
      },
    })
    .then((res) => {
      const allProporcion = res.data;

      // Eliminar duplicados por 'idColor'
      const unicos = allProporcion.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.colores[0]._id === item.colores[0]._id)
      );

      setArrayColores(unicos);
    })
    .catch((err) => console.log(err));

  setIdEditArticulo(idEdit);
  toggleTablaColores();
}

  function abrirAjuste(row) {
    setAjusteIdInv(row._id);
    setAjusteIdArt(row.idArticulo);
    setAjusteIdArea(row.idArea);
    setAjusteCodigo(row.codigo);
    setAjusteNombre(row.nombre);
    setAjusteArea(row.area);
    setAjusteCantInv(parseFloat(row.cantidad) || 0);
    setAjusteCantidadReal(parseFloat(row.cantidad) || 0);
    toggleAjuste();
  }

  async function guardarAjuste() {
    const cantidadReal = parseFloat(ajusteCantidadReal);
    const delta = cantidadReal - ajusteCantInv;
    if (isNaN(cantidadReal)) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Cantidad invalida" });
      return;
    }
    if (delta === 0) {
      Swal.fire({ icon: "info", title: "Sin cambios", text: "La cantidad es igual al inventario actual" });
      return;
    }
    setAjusteValidando(true);
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    try {
      // 1. Crear el AjusteInventario header (ya autorizado)
      const { data: ajuste } = await axios.post(
        URL_AJUSTES_INVENTARIO,
        {
          fecha: moment().format("YYYY-MM-DD"),
          areas: ajusteIdArea,
          observaciones: `Ajuste desde Listado Inventarios - ${ajusteCodigo}`,
          user: user.id,
          total: delta,
          autorizado: "Si",
        },
        { headers }
      );
      // 2. Crear la linea ArticulosAjustesInv con el delta
      await axios.post(
        URL_ARTICULOS_AJUSTES_INV,
        {
          ajustesInventario: ajuste._id,
          articulos: ajusteIdArt,
          cantidad: delta,
          inventarios: ajusteIdInv,
          areas: ajusteIdArea,
        },
        { headers }
      );
      // 3. Disparar la autorizacion (aplica $inc al Inventario)
      await axios.patch(
        `${URL_ARTICULOS_AJUSTES_INV}/autorizado/${ajuste._id}`,
        {},
        { headers }
      );
      // 4. Log
      await axios.post(
        URL_LOGS,
        {
          tipo: "Ajuste Inventario",
          detalle: `${ajusteCodigo} ${ajusteArea}: ${ajusteCantInv} -> ${cantidadReal} (${delta > 0 ? "+" : ""}${delta})`,
          user: user.id,
        },
        { headers }
      );
      Swal.fire("Listo", "Ajuste aplicado", "success");
      setTimeout(() => window.location.reload(), 800);
    } catch (err) {
      console.log(err);
      Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
      setAjusteValidando(false);
    }
  }

  function abrirPrecio(row) {
    setPrecioIdArt(row.idArticulo);
    setPrecioCodigo(row.codigo);
    setPrecioNombre(row.nombre);
    setPrecioVentaActual(parseFloat(row.venta) || 0);
    setPrecioVentaNueva(parseFloat(row.venta) || 0);
    setPrecioVenta2Actual(parseFloat(row.venta2) || 0);
    setPrecioVenta2Nueva(parseFloat(row.venta2) || 0);
    setPrecioVenta3Actual(parseFloat(row.venta3) || 0);
    setPrecioVenta3Nueva(parseFloat(row.venta3) || 0);
    setPrecioVenta4Actual(parseFloat(row.venta4) || 0);
    setPrecioVenta4Nueva(parseFloat(row.venta4) || 0);
    togglePrecio();
  }

  async function guardarPrecio() {
    const v1 = parseFloat(precioVentaNueva);
    const v2 = parseFloat(precioVenta2Nueva);
    const v3 = parseFloat(precioVenta3Nueva);
    const v4 = parseFloat(precioVenta4Nueva);
    if ([v1, v2, v3, v4].some((n) => isNaN(n) || n < 0)) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Algun precio es invalido" });
      return;
    }
    // Solo mandamos las listas que cambiaron, para no sobreescribir innecesariamente.
    const payload = {};
    if (v1 !== precioVentaActual) payload.venta = v1;
    if (v2 !== precioVenta2Actual) payload.venta2 = v2;
    if (v3 !== precioVenta3Actual) payload.venta3 = v3;
    if (v4 !== precioVenta4Actual) payload.venta4 = v4;
    if (Object.keys(payload).length === 0) {
      Swal.fire({ icon: "info", title: "Sin cambios", text: "Ningun precio cambio" });
      return;
    }
    setPrecioValidando(true);
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    try {
      await axios.patch(`${URL_ARTICULOS}/${precioIdArt}`, payload, { headers });
      const detalleCambios = Object.entries(payload)
        .map(([k, v]) => `${k}=${v}`)
        .join(", ");
      await axios.post(
        URL_LOGS,
        {
          tipo: "Editar Precio Articulo",
          detalle: `${precioCodigo}: ${detalleCambios}`,
          user: user.id,
        },
        { headers }
      );
      Swal.fire("Listo", "Precios actualizados", "success");
      setTimeout(() => window.location.reload(), 800);
    } catch (err) {
      console.log(err);
      Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
      setPrecioValidando(false);
    }
  }

  function abrirUnificar(row) {
    setUniSourceIdInv(row._id);
    setUniSourceIdArt(row.idArticulo);
    setUniSourceCodigo(row.codigo);
    setUniSourceNombre(row.nombre);
    setUniSourceCantidad(parseFloat(row.cantidad) || 0);
    setUniSourceIdArea(row.idArea);
    setUniSourceArea(row.area);
    // Opciones: otros articulos del MISMO almacen, excluyendo este mismo articulo.
    // Deduplicamos por idArticulo: si hubiera mas de un registro de inventario
    // del mismo articulo en el area, nos quedamos con uno solo para no aplicar
    // el $inc sobre un _id equivocado.
    const vistos = new Set();
    const opciones = comments
      .filter((c) => {
        if (String(c.idArea) !== String(row.idArea)) return false;
        if (String(c.idArticulo) === String(row.idArticulo)) return false;
        const key = String(c.idArticulo);
        if (vistos.has(key)) return false;
        vistos.add(key);
        return true;
      })
      .sort((a, b) => (a.codigo > b.codigo ? 1 : -1));
    setUniOpciones(opciones);
    setUniTargetIdInv("");
    setUniTargetIdArt("");
    toggleUnificar();
  }

  async function guardarUnificar() {
    if (!uniTargetIdInv || !uniTargetIdArt) {
      Swal.fire({ icon: "error", title: "Oops...", text: "Selecciona el otro modelo" });
      return;
    }
    if (uniSourceCantidad <= 0) {
      Swal.fire({ icon: "info", title: "Sin cambios", text: "No hay cantidad para unificar" });
      return;
    }
    setUniValidando(true);
    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    const delta = parseFloat(uniSourceCantidad) || 0;
    const target = uniOpciones.find(
      (o) => String(o._id) === String(uniTargetIdInv)
    );
    try {
      const { data: ajuste } = await axios.post(
        URL_AJUSTES_INVENTARIO,
        {
          fecha: moment().format("YYYY-MM-DD"),
          areas: uniSourceIdArea,
          observaciones: `Unificar ${uniSourceCodigo} -> ${target ? target.codigo : "?"}`,
          user: user.id,
          total: 0,
          autorizado: "Si",
        },
        { headers }
      );
      // Linea 1: resta del articulo fuente
      await axios.post(
        URL_ARTICULOS_AJUSTES_INV,
        {
          ajustesInventario: ajuste._id,
          articulos: uniSourceIdArt,
          cantidad: -delta,
          inventarios: uniSourceIdInv,
          areas: uniSourceIdArea,
        },
        { headers }
      );
      // Linea 2: suma al articulo destino
      await axios.post(
        URL_ARTICULOS_AJUSTES_INV,
        {
          ajustesInventario: ajuste._id,
          articulos: uniTargetIdArt,
          cantidad: delta,
          inventarios: uniTargetIdInv,
          areas: uniSourceIdArea,
        },
        { headers }
      );
      // Autorizar -> aplica $inc a ambos Inventarios
      await axios.patch(
        `${URL_ARTICULOS_AJUSTES_INV}/autorizado/${ajuste._id}`,
        {},
        { headers }
      );
      await axios.post(
        URL_LOGS,
        {
          tipo: "Unificar Modelos",
          detalle: `${uniSourceCodigo} -> ${target ? target.codigo : "?"} (${uniSourceArea}, ${delta} pzas)`,
          user: user.id,
        },
        { headers }
      );
      Swal.fire("Listo", "Modelos unificados", "success");
      setTimeout(() => window.location.reload(), 800);
    } catch (err) {
      console.log(err);
      Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
      setUniValidando(false);
    }
  }

  async function traspasarTodoAlmacen() {
    if (!selectedArea || selectedArea == "0") {
      Swal.fire({ icon: "info", title: "Filtra primero por almacen", text: "Selecciona el almacen origen en el filtro." });
      return;
    }
    // Lineas del almacen origen con cantidad > 0.
    const lineas = comments.filter(
      (c) => String(c.idArea) === String(selectedArea) && parseFloat(c.cantidad) > 0
    );
    if (lineas.length === 0) {
      Swal.fire({ icon: "info", title: "Sin stock", text: "El almacen no tiene articulos con cantidad mayor a 0." });
      return;
    }
    // Destinos: almacenes activos, menos el de origen.
    const destinos = areas
      .filter((a) => a.is_active === "Si" && String(a._id) !== String(selectedArea))
      .sort((a, b) => (a.name > b.name ? 1 : -1));
    if (destinos.length === 0) {
      Swal.fire({ icon: "info", title: "Sin destino", text: "No hay otro almacen activo para traspasar." });
      return;
    }
    const nombreArea = lineas[0].area || "almacen";
    const totalPzas = lineas.reduce((acc, l) => acc + (parseFloat(l.cantidad) || 0), 0);
    const ok = await Swal.fire({
      title: "Traspasar todo el almacen",
      html: `Vas a traspasar <b>${lineas.length}</b> modelos (${new Intl.NumberFormat("en-US").format(totalPzas)} pzas) de <b>${nombreArea}</b> al almacen que elijas.<br/><br/>Esta operacion no se puede deshacer facilmente.<br/><br/><b>Almacen destino:</b>`,
      icon: "warning",
      input: "select",
      inputOptions: Object.fromEntries(destinos.map((a) => [a._id, a.name])),
      // CEDIS de entrada, que era el unico destino antes.
      inputValue: destinos.some((a) => String(a._id) === String(AREAS_CEDIS)) ? AREAS_CEDIS : "",
      inputPlaceholder: "Selecciona",
      inputValidator: (v) => (!v ? "Selecciona el almacen destino" : undefined),
      showCancelButton: true,
      confirmButtonText: "Si, traspasar",
      cancelButtonText: "Cancelar",
    });
    if (!ok.isConfirmed || !ok.value) return;
    const areaDestino = ok.value;
    const nombreDestino = destinos.find((a) => String(a._id) === String(areaDestino))?.name || "almacen";

    const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };
    const totalCantidad = totalPzas;
    const totalGeneral = lineas.reduce(
      (acc, l) =>
        acc +
        (parseFloat(l.cantidad) || 0) * (parseFloat(l.venta) || 0),
      0
    );

    try {
      // 1. Header TraspasoSalida
      const { data: salida } = await axios.post(
        URL_TRASPASOS_SALIDA,
        {
          fecha: moment().format("YYYY-MM-DD"),
          areaSalida: selectedArea,
          areaDestino,
          observaciones: `Traspaso total a ${nombreDestino} desde ${nombreArea}`,
          user: user.id,
          total: totalCantidad,
          fotoEvidencia: "No",
          total_general: totalGeneral,
          saldo: totalGeneral,
        },
        { headers }
      );

      // 2. ArticulosTS por cada linea (el back resta del origen y suma al destino)
      await Promise.all(
        lineas.map((l) =>
          axios.post(
            URL_ARTICULOS_TS,
            {
              traspasosSalida: salida._id,
              articulos: l.idArticulo,
              cantidad: parseFloat(l.cantidad),
              surtido: parseFloat(l.cantidad),
              inventarios: l._id,
              areas: selectedArea,
              areaDestino,
              costoUnitario: parseFloat(l.costoUSD) || 0,
              precio: parseFloat(l.venta) || 0,
              total: (parseFloat(l.cantidad) || 0) * (parseFloat(l.venta) || 0),
            },
            { headers }
          )
        )
      );

      // 3. TraspasoEntrada (marca recibida:"Si" en el back)
      const { data: entrada } = await axios.post(
        URL_TRASPASOS_ENTRADA,
        {
          fecha: moment().format("YYYY-MM-DD"),
          traspasosSalida: salida._id,
          observaciones: `Traspaso total a ${nombreDestino} desde ${nombreArea}`,
          user: user.id,
          total: totalCantidad,
        },
        { headers }
      );

      // 4. Recuperar ArticulosTS recien creados para tener sus _id
      const { data: artsTS } = await axios.get(
        `${URL_ARTICULOS_TS}/traspasoSalida/${salida._id}`,
        { headers }
      );

      // 5. ArticulosTE
      await Promise.all(
        artsTS.map((a) =>
          axios.post(
            URL_ARTICULOS_TE,
            {
              articulosTS: a._id,
              traspasosEntrada: entrada._id,
              articulos: Array.isArray(a.articulos)
                ? a.articulos[0]?._id || a.articulos[0]
                : a.articulos?._id || a.articulos,
              cantidad: a.cantidad,
              areas: areaDestino,
              areaDestino,
              costoUnitario: a.costoUnitario,
            },
            { headers }
          )
        )
      );

      // 6. Log
      await axios.post(
        URL_LOGS,
        {
          tipo: "Traspaso Total de Almacen",
          detalle: `De ${nombreArea} a ${nombreDestino}: ${lineas.length} modelos, ${totalCantidad} pzas`,
          user: user.id,
        },
        { headers }
      );

      Swal.fire("Listo", "Traspaso completado", "success");
      setTimeout(() => window.location.reload(), 1000);
    } catch (err) {
      console.log(err);
      Swal.fire({ icon: "error", title: "Oops...", text: "Something went wrong!" });
    }
  }


  let total = 0;
  let total_cajas = 0;
  let total_disponible = 0;
  // Total en dinero de la lista de precios seleccionada (cantidad * precio)
  let total_dinero = 0;
  return (
    <>
      <Header />
      <br />
      <br />
      {user.inventarios || user.inventariosTiendas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {/* <Button
                size="sm"
                href="/MenuInventarios"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button> */}
              
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PromptListaParaPDF}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={PromptExcel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
                 <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excelConImagenes}
                >
                  Excel Foto<i class="far fa-file-excel"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="warning"
                  disabled={!selectedArea || selectedArea == "0"}
                  title={
                    !selectedArea || selectedArea == "0"
                      ? "Filtra primero por almacen"
                      : "Traspasar todo el almacen filtrado al almacen que elijas"
                  }
                  onClick={traspasarTodoAlmacen}
                >
                  Traspasar almacen <i class="fas fa-truck"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Inventarios</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
         
          <h3 align="center">Inventario General</h3>
          <div className="row">
            {/*<div className="col-md-10">
               <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              /> 
            </div> */}
            <div className="col-md-11 d-flex flex-row-reverse align-items-center">
              <Search
                scanMode
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
              {/* Rango de cantidad, a la altura del buscador */}
              <Input
                bsSize="sm"
                type="number"
                placeholder="Menor que"
                style={{ width: 120, marginRight: 8 }}
                value={cantidadMenorQue}
                onChange={(e) => {
                  setCantidadMenorQue(e.target.value);
                  setCurrentPage(1);
                }}
              />
              <Input
                bsSize="sm"
                type="number"
                placeholder="Mayor que"
                style={{ width: 120, marginRight: 8 }}
                value={cantidadMayorQue}
                onChange={(e) => {
                  setCantidadMayorQue(e.target.value);
                  setCurrentPage(1);
                }}
              />
              <Label
                className="mr-sm-2"
                style={{ marginBottom: 0, marginRight: 8, whiteSpace: "nowrap" }}
              >
                Cantidad:
              </Label>
            </div>
             <div className="col-md-1 flex-row-reverse">
            <Button
                  size="sm"
                  className="btn"
                  color="info"
                  onClick={limpiarSearch}
                >
                  Limpiar
                </Button>
                </div>
           
          </div>
          <br />
          <div className="table-wrapper">
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td style={{ paddingTop: "0px" }}>
                <Autocomplete
                  size="small"
                  options={opcionesArticulos}
                  groupBy={(option) => option.firstLetter}
                  getOptionLabel={(option) => String(option.codigo ?? "")}
                  value={
                    opcionesArticulos.find(
                      (o) => String(o._id) === String(selectedArticulo)
                    ) || null
                  }
                  onChange={(event, opt) => {
                    setSelectedArticulo(opt ? opt._id : "");
                    setCurrentPage(1);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Codigo" variant="outlined" />
                  )}
                  renderOption={(option) => (
                    <React.Fragment>
                      {option.codigo} {option.nombre}
                    </React.Fragment>
                  )}
                />
              </td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArticulo}
                  onChange={(e) => {
                    setSelectedArticulo(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {[...articulos]
                    .sort((a, b) =>
                      String(a.nombre ?? "").localeCompare(
                        String(b.nombre ?? ""),
                        undefined,
                        { numeric: true, sensitivity: "base" }
                      )
                    )
                    .map((a) => {
                      return <option value={a._id}>{a.nombre}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedFamiliaFiltro}
                  onChange={(e) => {
                    setSelectedFamiliaFiltro(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {[...familias]
                    .sort((a, b) =>
                      String(a.name ?? "").localeCompare(
                        String(b.name ?? ""),
                        undefined,
                        { numeric: true, sensitivity: "base" }
                      )
                    )
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedColeccion}
                  onChange={(e) => {
                    setSelectedColeccion(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {[...colecciones]
                    .sort((a, b) =>
                      String(a.name ?? "").localeCompare(
                        String(b.name ?? ""),
                        undefined,
                        { numeric: true, sensitivity: "base" }
                      )
                    )
                    .map((a) => {
                      return <option value={a._id}>{a.name}</option>;
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={listaPrecio}
                  onChange={(e) => setListaPrecio(e.target.value)}
                >
                  <option value="1">Lista Milano</option>
                  <option value="2">Lista 2</option>
                  <option value="3">Lista 3</option>
                  <option value="4">Lista 4</option>
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
              <Input
                  bsSize="sm"
                  type="select"
                  value={filtroCantidad}
                  onChange={(e) => {
                    setFiltroCantidad(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Todos</option>
                  <option value="ConCantidad">Con cantidad</option>
                  <option value="En0">En 0</option>
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedArea}
                  onChange={(e) => {
                    setSelectedArea(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {(() => {
                    // Todas las activas (aunque esten en 0) +
                    // inactivas que tengan stock > 0.
                    const idsAreasConStock = new Set(
                      (comments || [])
                        .filter((c) => parseFloat(c.cantidad) > 0)
                        .map((c) => String(c.idArea))
                    );
                    return areas
                      .filter(
                        (a) =>
                          a.is_active === "Si" ||
                          idsAreasConStock.has(String(a._id))
                      )
                      .sort((a, b) => (a.name > b.name ? 1 : -1))
                      .map((a) => (
                        <option value={a._id}>{a.name}</option>
                      ));
                  })()}
                </Input>
              </td>
              <td></td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                total = total + parseFloat(a.cantidad);
                total_cajas = total_cajas + parseFloat(a.cajas);
                total_disponible = total_disponible + calculaDisponible(a);
                total_dinero =
                  total_dinero +
                  (parseFloat(a.cantidad) || 0) *
                    (parseFloat(a[ventaKeySel]) || 0);
                {
                  return (
                    <tr>
                      <td>{a.codigo}</td>
                      <td>{a.codigoCliente}</td>
                      <td>{a.nombre}</td>
                      <td>{a.familia}</td>
                      <td>{a.coleccion}</td>
                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(
                          parseFloat(
                            a[listaPrecio === "1" ? "venta" : `venta${listaPrecio}`]
                          ) || 0
                        )}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(a.cantidad)}
                      </td>
                      <td>
                        {new Intl.NumberFormat("en-US").format(
                          calculaDisponible(a)
                        )}
                      </td>
                      <td>{a.area}</td>
                      <td>
                        <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                tablaColores(
                                  a.idArticulo
                                )
                              }
                            >
                              <i class="fas fa-palette"></i>
                            </Button>
                      <Button
                              color="info"
                              id="Editar"
                              size="sm"
                              onClick={(e) =>
                                jalaFoto(
                                  a.idArticulo
                                )
                              }
                            >
                              <i class="fas fa-camera"></i>
                            </Button>
                            <Button
                              color="warning"
                              size="sm"
                              title="Ajustar Cantidad"
                              onClick={() => abrirAjuste(a)}
                            >
                              <i class="fas fa-balance-scale"></i>
                            </Button>
                            <Button
                              color="success"
                              size="sm"
                              title="Editar Precio Venta"
                              onClick={() => abrirPrecio(a)}
                            >
                              <i class="fas fa-dollar-sign"></i>
                            </Button>
                            <Button
                              color="dark"
                              size="sm"
                              title="Unificar Modelos"
                              disabled={parseFloat(a.cantidad) <= 0}
                              onClick={() => abrirUnificar(a)}
                            >
                              <i class="fas fa-object-group"></i>
                            </Button>

                      </td>
                    </tr>
                  );
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(total_dinero)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(total)}
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(total_disponible)}
                </td>
                <td></td>
                <td></td>
              </tr>
              {/*<tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita">TOTAL GENERAL</td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US").format(totalTotal)}
                </td>
                <td></td>
                <td></td>
                <td></td>
              </tr>*/}
            </tbody>
          </Table>
          </div>
          {/* <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div> */}
        </div>
      ) : undefined}
  <Modal size="sm" isOpen={modalFoto} toggle={toggleFoto}>
        <ModalHeader toggle={toggleFoto}>
          <h4>
            Ficha Tecnica
          </h4>
        </ModalHeader>
        <ModalBody>
        <Row>
            {photo ? (
              <h6 style={{ textAlign: "center" }}>
                <img
                  // loading="lazy"
                  src={`${process.env.REACT_APP_URL_FOTO_CLOUDINARY}/image/upload/v${photo}/fcFashionArticulos/${idEditArticulo}.jpg`}
                  alt=""
                />
              </h6>
            ) : <h4>No se ha subido una Ficha Tecnica....</h4>}
          </Row>
        </ModalBody>
      </Modal>


        <Modal size="sm" isOpen={modalTablaColores} toggle={toggleTablaColores}>
        <ModalHeader toggle={toggleTablaColores}>
          <h4>
            Colores
          </h4>
        </ModalHeader>
        <ModalBody>
        <Row>
          <Table size="sm" striped borderless className="table-responsive-xl">
            <tbody>
              {arrayColores.map((a) => {
                {
                  return (
                    <tr>
                      <td>{a.colores[0].name}</td>
                    </tr>
                  );
                }
              })}
            </tbody>
            </Table>
          </Row>
        </ModalBody>
      </Modal>

      {/* Modal Ajuste Cantidad */}
      <Modal size="sm" isOpen={modalAjuste} toggle={toggleAjuste}>
        <ModalHeader toggle={toggleAjuste}>Ajustar Cantidad</ModalHeader>
        <ModalBody>
          <Label>Articulo</Label>
          <Input type="text" value={`${ajusteCodigo} ${ajusteNombre}`} disabled />
          <Label>Almacen</Label>
          <Input type="text" value={ajusteArea} disabled />
          <Label>Inventario Actual</Label>
          <Input type="number" value={ajusteCantInv} disabled />
          <Label>Cantidad Real</Label>
          <Input
            type="number"
            step="any"
            value={ajusteCantidadReal}
            onChange={(e) => setAjusteCantidadReal(e.target.value)}
          />
          <br />
          {(() => {
            const real = parseFloat(ajusteCantidadReal);
            const delta = isNaN(real) ? 0 : real - ajusteCantInv;
            if (delta === 0) return <span style={{ color: "#666" }}>Sin cambio</span>;
            const positivo = delta > 0;
            return (
              <span style={{ color: positivo ? "#28a745" : "#dc3545", fontWeight: "bold" }}>
                Ajuste: {positivo ? "+" : ""}{delta} pzas {positivo ? "(Entrada)" : "(Salida)"}
              </span>
            );
          })()}
        </ModalBody>
        <ModalFooter>
          <Button color="success" size="sm" disabled={ajusteValidando} onClick={guardarAjuste}>
            Guardar
          </Button>
          <Button color="secondary" size="sm" onClick={toggleAjuste}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Editar Precios (4 listas) */}
      <Modal isOpen={modalPrecio} toggle={togglePrecio}>
        <ModalHeader toggle={togglePrecio}>Editar Precios</ModalHeader>
        <ModalBody>
          <Label>Articulo</Label>
          <Input type="text" value={`${precioCodigo} ${precioNombre}`} disabled />
          <br />
          <Row>
            <Col md={6}>
              <Label>Lista Milano - Actual</Label>
              <Input type="number" value={precioVentaActual} disabled />
            </Col>
            <Col md={6}>
              <Label>Lista Milano - Nuevo</Label>
              <Input
                type="number"
                step="any"
                min="0"
                value={precioVentaNueva}
                onChange={(e) => setPrecioVentaNueva(e.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label>Lista 2 - Actual</Label>
              <Input type="number" value={precioVenta2Actual} disabled />
            </Col>
            <Col md={6}>
              <Label>Lista 2 - Nuevo</Label>
              <Input
                type="number"
                step="any"
                min="0"
                value={precioVenta2Nueva}
                onChange={(e) => setPrecioVenta2Nueva(e.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label>Lista 3 - Actual</Label>
              <Input type="number" value={precioVenta3Actual} disabled />
            </Col>
            <Col md={6}>
              <Label>Lista 3 - Nuevo</Label>
              <Input
                type="number"
                step="any"
                min="0"
                value={precioVenta3Nueva}
                onChange={(e) => setPrecioVenta3Nueva(e.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <Label>Lista 4 - Actual</Label>
              <Input type="number" value={precioVenta4Actual} disabled />
            </Col>
            <Col md={6}>
              <Label>Lista 4 - Nuevo</Label>
              <Input
                type="number"
                step="any"
                min="0"
                value={precioVenta4Nueva}
                onChange={(e) => setPrecioVenta4Nueva(e.target.value)}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="success" size="sm" disabled={precioValidando} onClick={guardarPrecio}>
            Guardar
          </Button>
          <Button color="secondary" size="sm" onClick={togglePrecio}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {/* Modal Unificar Modelos */}
      <Modal isOpen={modalUnificar} toggle={toggleUnificar}>
        <ModalHeader toggle={toggleUnificar}>Unificar Modelos</ModalHeader>
        <ModalBody>
          <Label>Modelo fuente</Label>
          <Input
            type="text"
            value={`${uniSourceCodigo} ${uniSourceNombre}`}
            disabled
          />
          <Label>Almacen</Label>
          <Input type="text" value={uniSourceArea} disabled />
          <Label>Cantidad a mover (todo el stock fuente)</Label>
          <Input type="number" value={uniSourceCantidad} disabled />
          <Label>Modelo destino (mismo almacen)</Label>
          <Autocomplete
            size="small"
            options={uniOpciones
              .map((o) => {
                const codigo = o.codigo || "";
                const firstChar = (codigo[0] || "X").toUpperCase();
                return {
                  ...o,
                  junta: `${codigo} ${o.nombre || ""} (stock: ${o.cantidad})`.trim(),
                  firstLetter: /[0-9]/.test(firstChar) ? "0-9" : firstChar,
                };
              })
              .sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
            groupBy={(option) => option.firstLetter}
            getOptionLabel={(option) => option.junta || ""}
            onChange={(event, selectedOption) => {
              if (selectedOption) {
                setUniTargetIdInv(selectedOption._id);
                setUniTargetIdArt(selectedOption.idArticulo);
              } else {
                setUniTargetIdInv("");
                setUniTargetIdArt("");
              }
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Selecciona modelo destino"
                variant="outlined"
              />
            )}
            renderOption={(option) => (
              <React.Fragment>
                {option.codigo} {option.nombre} (stock: {option.cantidad})
              </React.Fragment>
            )}
          />
          {uniOpciones.length === 0 ? (
            <p style={{ color: "#999", marginTop: 8 }}>
              No hay otros modelos en este almacen para unificar.
            </p>
          ) : null}
        </ModalBody>
        <ModalFooter>
          <Button
            color="success"
            size="sm"
            disabled={uniValidando || uniOpciones.length === 0}
            onClick={guardarUnificar}
          >
            Unificar
          </Button>
          <Button color="secondary" size="sm" onClick={toggleUnificar}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoInventarios;
